import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Loader } from '@ferris/react';
import withPageFlow from '../PageFlow/PageFlow';

export function JoinRedirect({
    bedroomCount, bathroomCount, placeId, address, pageFlow, fromMarketing
}) {
    useEffect(() => {
        const hasBedsOrBaths = bedroomCount > 0 || bathroomCount > 1;
        const hasAddress = address && Object.keys(address).some((k) => k !== 'country' && address[k]);

        if (!fromMarketing && !hasBedsOrBaths) {
            pageFlow.browseToNextPage('property-details', true);
        } else if (!placeId || !hasAddress) {
            pageFlow.browseToNextPage('location', true);
        } else {
            pageFlow.browseToNextPage('manual-location', true);
        }
    }, []);

    return (
        <div className="update-account-wrapper">
            <Loader size="large" visible />
        </div>
    );
}

JoinRedirect.propTypes = {
    bedroomCount: PropTypes.number,
    bathroomCount: PropTypes.number,
    placeId: PropTypes.string,
    address: PropTypes.shape({}),
    pageFlow: PropTypes.shape({ browseToNextPage: PropTypes.func }).isRequired,
    fromMarketing: PropTypes.bool
};

JoinRedirect.defaultProps = {
    bedroomCount: 0,
    bathroomCount: 1,
    placeId: null,
    address: null,
    fromMarketing: false
};

const mapStateToProps = (state) => ({
    bedroomCount: state.app.lyp.bedroomCount,
    bathroomCount: state.app.lyp.bathroomCount,
    placeId: state.google.placeId,
    address: state.location.address,
    fromMarketing: state.app.lyp.fromMarketing
});

export default withPageFlow(connect(mapStateToProps)(JoinRedirect));
